/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-06 18:47:57
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-06 19:24:24
 * @FilePath: \senlan-ai-ui\src\routers\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState, useEffect } from 'react'
import {
  type RouteObject,
  RouterProvider,
  createHashRouter,
} from 'react-router-dom'

import useMessage from '../hooks/useMessage.ts'

import useSystemTheme from '../hooks/useSystemTheme.ts'
import staticRoutes from './modules/StaticRoutes.tsx'

import type { RouteItemType } from './types/index.ts'

const RouterProvicer: React.FC = () => {
  useMessage() //消息提示弹窗
  useSystemTheme() //系统主题配置

  const [allRouteList, setAllRouteList] =
    useState<RouteItemType[]>(staticRoutes) //所有路由列表

  useEffect(() => {
    const allRouteList = [...staticRoutes] as RouteObject[]

    setAllRouteList(allRouteList)
  }, [])

  // 5.创建react-router路由管理对象
  // 注：history模式重定向到登录页时，会发生redux状态丢失，以至于当authMenuList改变时，页面会触发重新渲染，同时会有闪屏的现象。所以暂且使用hash模式）
  const routerMode = createHashRouter(allRouteList as RouteObject[])

  // 5.将路由管理对象传递给RouterProvider组件
  return <RouterProvider router={routerMode}></RouterProvider>
}

export default RouterProvicer
